(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/javascripts/api-calls/result.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/javascripts/api-calls/result.js');

'use strict';

const drawgamesApiCaller = svs.tur.apiCaller.drawgames;
const productMapping = svs.lyckoplatsen.components.shared_constants.productMapping;
async function fetchResult(product, drawNumber) {
  try {
    const {
      response
    } = await drawgamesApiCaller.getDrawProductDrawsResult({
      product: productMapping.getProductDrawId(product),
      drawNumber
    });
    return response.result;
  } catch (e) {
    svs.lyckoplatsen.logger.info('Failed to get result', e);
  }
}
Object.assign(svs.lyckoplatsen.components.shared_result.api_calls, {
  fetchResult
});

 })(window);